/*
 * Fig & Bloom — back to top. Styles and the why: snippets/back-to-top.liquid.
 *
 * Shows on a scroll UP once the shopper is well down the page, hides on a
 * scroll down and near the top. A few pixels of travel are ignored so the
 * jitter of a thumb resting on the screen, or iOS rubber-banding, doesn't
 * flicker it.
 */
(function () {
  var button = document.getElementById('scroll__top');
  if (!button) return;

  var SHOW_BELOW = 600; // px scrolled before it is worth offering
  var HIDE_ABOVE = 300; // px from the top where it has nothing to do
  var JITTER = 8;       // px of travel ignored either way

  var lastY = window.scrollY;
  var ticking = false;

  function setShown(on) {
    if (button.classList.contains('active') === on) return;
    button.classList.toggle('active', on);
    // Hidden, it is out of the tab order and away from screen readers.
    button.tabIndex = on ? 0 : -1;
    button.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  function update() {
    ticking = false;
    var y = window.scrollY;
    var delta = y - lastY;
    if (y < HIDE_ABOVE) {
      setShown(false);
    } else if (delta < -JITTER && y > SHOW_BELOW) {
      setShown(true);
    } else if (delta > JITTER) {
      setShown(false);
    }
    if (Math.abs(delta) > JITTER) lastY = y;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }, { passive: true });

  button.setAttribute('aria-hidden', 'true');
  button.addEventListener('click', function (event) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduce ? 'auto' : 'smooth' });
    setShown(false);
    // From a keyboard (a click with no pointer, detail 0), hand focus to the
    // top of the page too, where the shopper now is. A tap leaves focus alone
    // so no focus ring flashes up in the header.
    if (event.detail === 0) {
      var first = document.querySelector('.skip-to-content-link') || document.querySelector('header a, header button');
      if (first && first.focus) first.focus({ preventScroll: true });
    }
  });
})();
